'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconWindowText, iconWindowTextTag } from '@ni/nimble-components/dist/esm/icons/window-text';
import { wrap } from '../../utilities/react-wrapper';

export type { IconWindowText };
export { iconWindowTextTag };
export const NimbleIconWindowText = wrap(IconWindowText);